import * as Actions from '../actions';

const initialState = {
	role: ["Head Admin"], // guest
	data: {
		authToken: '',
		email: '',
		name: '',
		position: '',
		profile_image: '',
		userstatu: '',
	}
};

const user = (state = initialState, action) => {
	switch (action.type) {
		case Actions.GET_USER_DATA: {
			return {
				...initialState,
				...action.payload
			};
		}
		case Actions.SET_USER_DATA: {
			return {
				...initialState,
				data: action.payload
			};
		}
		case Actions.REMOVE_USER_DATA: {
			return {
				...initialState
			};
		}
		case Actions.USER_LOGGED_OUT: {
			return initialState;
		}
		default: {
			return state;
		}
	}
};

export default user;